import lightFormat from 'date-fns/lightFormat';
import { EServiceId } from '../../../../../../../types/reducers/publishTerms';
import { IPreparedPackage } from '../types';
import { IPackage } from '../../../../../../../reducers/v2/publicationPackages/types';

const PACKAGE_NAMES: { [serviceId in EServiceId]: string } = {
  [EServiceId.top]: 'Топ',
  [EServiceId.premium]: 'Премиум',
  [EServiceId.paid]: 'Публикация',
  [EServiceId.free]: 'Публикация',
};

const DATE_PATTERN = 'dd.MM';

export function preparePackages(packages: IPackage[]): IPreparedPackage[] {
  return packages.map(servicePackage => {
    const { id, offersCount: count, serviceId, endDate } = servicePackage;

    const formattedEndDate = lightFormat(new Date(endDate), DATE_PATTERN);
    const packageName = PACKAGE_NAMES[serviceId];

    const description = count ? `(доступно ${count} до ${formattedEndDate})` : `(до ${formattedEndDate})`;

    return {
      value: id,
      label: `${packageName} ${description}`,
    };
  });
}
